<h1 mat-dialog-title>Select EV Group</h1>
<div mat-dialog-content>
  <div class="row justify-content-center pb-2 dense-1">
    <mat-form-field>
      <mat-label>EV Group</mat-label>
      <mat-select [formControl]="selectedGroup">
        @for (type of codeTypes; track type.id) {
          <mat-option [value]="type.actv_code_type_id">
            @if (isPortfolio) {
              {{ type.projectName }}:
            }
            {{ type.actv_code_type }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Cancel</button>
  <button matButton="filled" [mat-dialog-close]="submit()" cdkFocusInitial>Confirm</button>
</div>
